// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader--loader--dwYOs {
  display: flex;
  pointer-events: none;
}

.Loader--loaderDots--eqXFC {
  opacity: 1;
  transition: opacity .25s ease;
  display: flex;
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.Loader--loaderText--V2ecY {
  color: var(--text-high-contrast);
  font-size: 14px;
  display: flex;
  width: 100%;
  justify-content: center;
  position: absolute;
  top: calc(50% + 29px);
  left: 50%;
  transform: translate(-50%, -50%);
}

.Loader--loaderDots--eqXFC.Loader--overlay--nJPRz {
  background: radial-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.7));
}

.Loader--loaderDots--eqXFC.Loader--hidden--ClZJj {
  opacity: 0.01;
}

.Loader--loaderDot--eumH1 {
  margin: 5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--brand-purple-dark);
  transform: scale(0.5);
}

.Loader--loaderDot--eumH1.Loader--animating--fUk3W {
  animation: Loader--scale-dot--s89v6 1.2s ease-out infinite;
}

.Loader--loaderDot--eumH1:nth-of-type(2) {
  animation-delay: 0.2s;
}

.Loader--loaderDot--eumH1:nth-of-type(3) {
  animation-delay: 0.3s;
}

.Loader--loaderDot--eumH1:nth-of-type(4) {
  animation-delay: 0.4s;
}

.Loader--loaderDot--eumH1:nth-of-type(5) {
  animation-delay: 0.5s;
}

@keyframes Loader--scale-dot--s89v6 {
  0% {
    transform: scale(0.5);
  }
  25% {
    transform: scale(1);
  }
  75% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(0.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/loader/Loader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,0DAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".loader {\n  display: flex;\n  pointer-events: none;\n}\n\n.loaderDots {\n  opacity: 1;\n  transition: opacity .25s ease;\n  display: flex;\n  position: absolute;\n  z-index: 10;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.loaderText {\n  color: var(--text-high-contrast);\n  font-size: 14px;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  position: absolute;\n  top: calc(50% + 29px);\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.loaderDots.overlay {\n  background: radial-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.7));\n}\n\n.loaderDots.hidden {\n  opacity: 0.01;\n}\n\n.loaderDot {\n  margin: 5px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--brand-purple-dark);\n  transform: scale(0.5);\n}\n\n.loaderDot.animating {\n  animation: scale-dot 1.2s ease-out infinite;\n}\n\n.loaderDot:nth-of-type(2) {\n  animation-delay: 0.2s;\n}\n\n.loaderDot:nth-of-type(3) {\n  animation-delay: 0.3s;\n}\n\n.loaderDot:nth-of-type(4) {\n  animation-delay: 0.4s;\n}\n\n.loaderDot:nth-of-type(5) {\n  animation-delay: 0.5s;\n}\n\n@keyframes scale-dot {\n  0% {\n    transform: scale(0.5);\n  }\n  25% {\n    transform: scale(1);\n  }\n  75% {\n    transform: scale(0.5);\n  }\n  100% {\n    transform: scale(0.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `Loader--loader--dwYOs`,
	"loaderDots": `Loader--loaderDots--eqXFC`,
	"loaderText": `Loader--loaderText--V2ecY`,
	"overlay": `Loader--overlay--nJPRz`,
	"hidden": `Loader--hidden--ClZJj`,
	"loaderDot": `Loader--loaderDot--eumH1`,
	"animating": `Loader--animating--fUk3W`,
	"scale-dot": `Loader--scale-dot--s89v6`
};
export default ___CSS_LOADER_EXPORT___;
